import React from 'react';
import { useFirebaseAuth } from '../auth';

export default function FeedbackFAB() {
  const { user } = useFirebaseAuth();
  const [sdkAvailable, setSdkAvailable] = React.useState(false);

  // Initialize UserJot widget when component mounts
  React.useEffect(() => {
    // Check if SDK is available after a short delay to allow it to load
    let timeoutId = null;
    
    const checkSDK = () => {
      if (window.uj && typeof window.uj.init === 'function') {
        window.uj.init('cmi6fv5hf001614ozm1ris57s', {
          widget: true,
          position: 'right',
          theme: 'auto'
        });
        setSdkAvailable(true);
      } else {
        // Check again after a delay in case SDK is still loading
        timeoutId = setTimeout(() => {
          if (window.uj && typeof window.uj.init === 'function') {
            window.uj.init('cmi6fv5hf001614ozm1ris57s', {
              widget: true,
              position: 'right',
              theme: 'auto'
            });
            setSdkAvailable(true);
          } else {
            setSdkAvailable(false);
          }
        }, 2000);
      }
    };

    checkSDK();
    
    // Cleanup function to clear timeout if component unmounts
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  // Identify user when user data is available
  React.useEffect(() => {
    if (user && window.uj && typeof window.uj.identify === 'function') {
      // Extract firstName and lastName from displayName
      const displayName = user.displayName || '';
      const nameParts = displayName.trim().split(/\s+/);
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || '';

      window.uj.identify({
        id: user.uid,
        email: user.email || '',
        firstName: firstName,
        lastName: lastName,
        avatar: user.photoURL || '',
      });
    }
  }, [user]);

  // Fallback: Show custom button if SDK is not available
  const handleClick = () => {
    if (window.uj && typeof window.uj.open === 'function') {
      window.uj.open();
    } else {
      // Fallback to opening in new window if SDK method not available
      window.open('https://neutrino-uptime.userjot.com/', '_blank', 'noopener,noreferrer');
    }
  };

  // Only render custom button if SDK widget is not available
  if (sdkAvailable) {
    return null;
  }

  return (
    <button
      className="feedback-fab"
      onClick={handleClick}
      aria-label="Leave feedback"
      title="Leave feedback"
    >
      <span className="material-icons">feedback</span>
    </button>
  );
}

